/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PathwayUser = {
    adId?: string;
    firstName?: string;
    lastName?: string;
    locationList?: Array<string>;
    name?: string;
    personId?: string;
    prefName?: string;
    startDate?: string;
    userType?: PathwayUser.userType;
    username?: string;
};

export namespace PathwayUser {

    export enum userType {
        TEAM_MEMBER = 'TEAM_MEMBER',
        OPERATOR = 'OPERATOR',
        STAFF = 'STAFF',
    }


}

